import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { startTimer, clearTimer } from '../actions/inactivityWarning';

import InactivityWarning from '../components/InactivityWarning';

export default connect(
  state => ({
    isLoggedIn: isUserLoggedIn(state.user),
  }), {
    clearTimer,
    startTimer,
  }
)(InactivityWarning);
